import React, { useEffect, useState } from 'react'
import { ElementData, ElementDataValue, EntityData, FormElement } from '../../lib/types'
import ChangeIndicator from './change-indicator'
import { entities } from '../../lib/api'
import EntitySearch from '../entity-search'
import { Tooltip } from '@carbon/react'
import { Information } from '@carbon/icons-react'
import { formatDate } from '../../workflows/util'
import { getCaseInsensitive } from '../../lib/get-id'

type Props = {
    original: ElementData
    data: ElementData
    prevData?: ElementData
    element: FormElement
    onChange: (field: string, value: ElementDataValue) => void
}

export default function EntityElement(props: Props) {
    const { element, data, prevData, original, onChange } = props
    const [text, setText] = useState('')
    const [loaded, setLoaded] = useState(false)
    const [err, setErr] = useState('')

    let value = getCaseInsensitive(data, element.field || '')
    let changed =
        value !== getCaseInsensitive(original, element.field || '') ||
        (prevData ? value !== getCaseInsensitive(prevData, element.field || '') : false)

    // Load the name if we're starting with the id
    useEffect(() => {
        if (loaded) return
        setLoaded(true)
        if (value) {
            entities
                .get(element.entity!, Number(value))
                .then((e) => {
                    const formattedDate = formatDate(String(e.name)?.substring(0, 10))
                    setText(formattedDate || e.name)
                })
                .catch((err) => setErr(err.message || err))
        }
    }, [value, element, loaded])

    function optionClick(entity: EntityData) {
        setText(entity.name)
        onChange(element.field!, Number(entity.id))
        setErr('')
    }

    function textChange(text: string) {
        setText(text)
        if (text === '') onChange(element.field!, null)
    }

    return (
        <div className='mt-2'>
            <label className='font-bold text-blue-700'>
                {element.label || element.field}
                {element.required && <span className='text-red-300 mx-1'>*</span>}
                {!element.readonly && <ChangeIndicator changed={changed} />}
                {changed && prevData && (
                    <Tooltip
                        align='bottom'
                        label={getCaseInsensitive(prevData, element.field || '') + ' → ' + text}
                    >
                        <span className='cursor-pointer ml-1 flex flex-row items-center'>
                            <Information />
                        </span>
                    </Tooltip>
                )}
            </label>
            {err && <div className='text-red-500'>{err}</div>}
            <EntitySearch
                entities={[element.entity!]}
                text={text}
                textChange={textChange}
                readonly={!!element.readonly}
                onErr={setErr}
                optionClick={optionClick}
                style={{ borderColor: changed ? 'Highlight' : '#ADB0B3' }}
            />
        </div>
    )
}
